import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-407244cb")

_pushScopeId("data-v-407244cb")
const _hoisted_1 = { class: "testimonials" }
const _hoisted_2 = { class: "title" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Testimonial = _resolveComponent("Testimonial")
  const _component_vueper_slide = _resolveComponent("vueper-slide")
  const _component_vueper_slides = _resolveComponent("vueper-slides")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("h3", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createVNode(_component_vueper_slides, {
      "dragging-distance": 70,
      "arrows-outside": "",
      autoplay: "",
      bullets: "",
      class: "testimonials-carousel no-shadow",
      "fixed-height": "250px",
      "prevent-y-scroll": "",
      onSlide: _ctx.blockClicks
    }, {
      default: _withId(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.testimonials, (testimonial, i) => {
          return (_openBlock(), _createBlock(_component_vueper_slide, { key: i }, {
            content: _withId(() => [
              _createVNode(_component_Testimonial, {
                icon: testimonial.icon,
                name: testimonial.name,
                suffix: testimonial.suffix,
                onClick: $event => (_ctx.onSlideClick(testimonial))
              }, {
                default: _withId(() => [
                  _createVNode("div", {
                    innerHTML: testimonial.content
                  }, null, 8, ["innerHTML"])
                ]),
                _: 2
              }, 1032, ["icon", "name", "suffix", "onClick"])
            ]),
            _: 2
          }, 1024))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 1
    }, 8, ["onSlide"])
  ]))
})